const notificationActionTypes = {
  markAsRead: 'notification/markAsRead',
  markAllAsRead: 'notification/markAllAsRead',
  markAllAsReceived: 'notification/markAllAsReceived',
  setNotificationList: 'notification/setNotificationList',
};

export default notificationActionTypes;
